import { LpAiModelsBlock } from "@/puck/landingBlocks";
import type { LandingComponents } from "@/puck/blocks/blockTypes";
import { AI_MODEL_BRAND_OPTIONS } from "@/constants/aiModelBrands";

export const aiModelsConfigs: Pick<LandingComponents, "LpAiModels"> = {
  LpAiModels: {
    label: "AI models (floating)",
    fields: {
      eyebrow: { type: "text" },
      titleLead: { type: "text", contentEditable: true },
      titleAccent: { type: "text", contentEditable: true },
      subtitle: { type: "textarea", contentEditable: true },
      footnoteLead: { type: "text", contentEditable: true },
      footnoteAccent: { type: "text", contentEditable: true },
      models: {
        type: "array",
        getItemSummary: (item) => item.name,
        defaultItemProps: {
          brandId: "openai",
          name: "OpenAI",
          sublabel: "GPT-4o · o-series",
        },
        arrayFields: {
          brandId: {
            type: "select",
            label: "Brand icon",
            options: AI_MODEL_BRAND_OPTIONS,
          },
          name: { type: "text", contentEditable: true },
          sublabel: { type: "text", contentEditable: true },
        },
      },
    },
    defaultProps: {
      eyebrow: "One login",
      titleLead: "One subscription.",
      titleAccent: "The best AI models.",
      subtitle:
        "OpenAI, Anthropic, and Google, side by side. Pick the best model for the task and switch any time.",
      footnoteLead: "No juggling subscriptions.",
      footnoteAccent: "One login, one bill, every model.",
      models: [
        { brandId: "openai", name: "OpenAI", sublabel: "GPT-4o · o-series" },
        { brandId: "claude", name: "Claude", sublabel: "Anthropic" },
        { brandId: "gemini", name: "Gemini", sublabel: "Google" },
      ],
    },
    render: LpAiModelsBlock,
  },
};
